import { Redirect } from 'expo-router';
import { useAtomValue } from 'jotai';
import { RowList, ScreenContainer } from 'smoothie';

import { closedImAccountsAtom } from '../state/investmentAtoms';
import { getAccountDisplayComponent } from './InvestmentsOverview';

export const ClosedAccounts = () => {
    const closedAccounts = useAtomValue(closedImAccountsAtom);
    if (closedAccounts.length === 0) {
        return <Redirect href="/home/investment" />;
    }

    const closedAccountsToShow = closedAccounts
        .sort((a, b) => {
            return (
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            );
        })
        .map((a) => {
            return getAccountDisplayComponent(a);
        });

    return (
        <ScreenContainer title="Closed accounts" hasBackButton={true}>
            <RowList
                rowHeaderProps={{ title: 'Your investment accounts' }}
                paddingVertical={12}
            >
                {closedAccountsToShow}
            </RowList>
        </ScreenContainer>
    );
};
